/**
 * Brand configuration for white label deployments
 *
 * Environment Variables:
 * - NEXT_PUBLIC_BRAND_NAME: Override the brand name (default: "Sigma Auth")
 * - NEXT_PUBLIC_BRAND_LOGO_URL: URL to custom logo image (optional)
 */

export interface BrandConfig {
	name: string;
	logoUrl?: string;
}

const defaultBrandConfig: BrandConfig = {
	name: "Sigma Auth",
	logoUrl: undefined,
};

/**
 * Get the current brand configuration
 * Allows customization via environment variables for white label deployments
 */
export function getBrandConfig(): BrandConfig {
	const config = { ...defaultBrandConfig };

	if (process.env.NEXT_PUBLIC_BRAND_NAME) {
		config.name = process.env.NEXT_PUBLIC_BRAND_NAME;
	}

	if (process.env.NEXT_PUBLIC_BRAND_LOGO_URL) {
		config.logoUrl = process.env.NEXT_PUBLIC_BRAND_LOGO_URL;
	}

	return config;
}
